import React, { useState, useEffect } from 'react';
import { exportApi } from '../api';

const TYP_OPTIONEN = [
  { value: 'vertraege', label: 'Verträge', icon: '📋' },
  { value: 'kosten', label: 'Kostenpositionen', icon: '💳' },
  { value: 'anbieter', label: 'Anbieter', icon: '🏢' },
  { value: 'kontakte', label: 'Kontakte', icon: '👤' },
  { value: 'kommunikation', label: 'Kommunikation', icon: '✉️' },
  { value: 'portabilitaet', label: 'Vollständiger Datenexport (DSGVO)', icon: '📦' },
];

export default function ExportPage() {
  const [typ, setTyp] = useState('vertraege');
  const [format, setFormat] = useState('csv');
  const [filter, setFilter] = useState({});
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [jobsLoading, setJobsLoading] = useState(true);
  const [err, setErr] = useState(null);

  const loadJobs = async () => {
    setJobsLoading(true);
    try { const r = await exportApi.list(); setJobs(r.jobs || []); }
    catch (e) { /* ignore */ }
    finally { setJobsLoading(false); }
  };

  useEffect(() => { loadJobs(); }, []);

  const handleExport = async () => {
    setLoading(true); setErr(null);
    try {
      const r = await exportApi.create(typ, format, filter);
      await loadJobs();
      // Auto-download if download_url available
      if (r.download_url) {
        window.open(r.download_url, '_blank');
      }
    } catch (e) { setErr(e.response?.data?.error || e.message); }
    finally { setLoading(false); }
  };

  const handleDownload = async (job) => {
    try {
      const url = exportApi.downloadUrl(job.id);
      window.open(url, '_blank');
    } catch (e) { alert(e.response?.data?.error || e.message); }
  };

  const statusFarbe = { bereit: '#22c55e', verarbeitung: '#f59e0b', fehler: '#ef4444', abgelaufen: '#64748b' };

  return (
    <div style={{ padding: 20, color: '#f1f5f9', maxWidth: 900 }}>
      <h1 style={{ fontSize: 22, fontWeight: 700, margin: '0 0 20px' }}>📤 Export</h1>

      {err && <div style={{ background: '#7f1d1d', padding: 12, borderRadius: 8, marginBottom: 14 }}>{err}</div>}

      {/* Exportkonfiguration */}
      <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: 10, padding: 20, marginBottom: 20 }}>
        <h2 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 600 }}>Neuen Export erstellen</h2>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 16 }}>
          <div>
            <label style={lbl}>Exporttyp</label>
            <select value={typ} onChange={e => setTyp(e.target.value)} style={sel}>
              {TYP_OPTIONEN.map(t => <option key={t.value} value={t.value}>{t.icon} {t.label}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>Format</label>
            <select value={format} onChange={e => setFormat(e.target.value)} style={sel}>
              <option value="csv">CSV</option>
              <option value="json">JSON</option>
            </select>
          </div>
        </div>

        {/* Filter für Verträge */}
        {typ === 'vertraege' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16 }}>
            <div>
              <label style={lbl}>Status (leer = alle)</label>
              <select value={filter.status || ''} onChange={e => setFilter(p => ({ ...p, status: e.target.value || undefined }))} style={sel}>
                <option value="">Alle Status</option>
                {['aktiv','inaktiv','gekündigt','abgelaufen'].map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div>
              <label style={lbl}>Kategorie (leer = alle)</label>
              <input value={filter.kategorie || ''} onChange={e => setFilter(p => ({ ...p, kategorie: e.target.value || undefined }))}
                placeholder="z.B. Versicherung" style={sel} />
            </div>
          </div>
        )}

        {/* DSGVO-Hinweis bei portabilitaet */}
        {typ === 'portabilitaet' && (
          <div style={{ background: '#0f172a', border: '1px solid #6366f1', borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 13, color: '#94a3b8' }}>
            <strong style={{ color: '#818cf8' }}>Datenportabilität (Art. 20 DSGVO)</strong>
            <p style={{ margin: '6px 0 0' }}>
              Exportiert alle Ihre personenbezogenen Daten. Passwort-Hashes und API-Tokens werden niemals exportiert.
              Der Export ist 24 Stunden verfügbar und anschließend gelöscht.
            </p>
          </div>
        )}

        <div style={{ background: '#0f172a', borderRadius: 8, padding: 12, marginBottom: 16, fontSize: 12, color: '#64748b' }}>
          <strong style={{ color: '#94a3b8' }}>Hinweise:</strong> Exporte sind 24 Stunden verfügbar und danach automatisch gelöscht.
          Downloads sind nicht öffentlich zugänglich – nur für Ihren Account.
        </div>

        <button onClick={handleExport} disabled={loading} className="btn-primary">
          {loading ? '⏳ Erstelle Export…' : '📤 Export erstellen'}
        </button>
      </div>

      {/* Exportliste */}
      <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: 10, padding: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>Meine Exporte</h2>
          <button onClick={loadJobs} className="btn-secondary">↺ Aktualisieren</button>
        </div>

        {jobsLoading ? (
          <div style={{ textAlign: 'center', color: '#6366f1', padding: 24 }}>⏳ Lade…</div>
        ) : jobs.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#64748b', padding: 24 }}>Noch keine Exporte vorhanden.</div>
        ) : (
          <div style={{ display: 'grid', gap: 8 }}>
            {jobs.map(j => (
              <div key={j.id} style={{ background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 500, fontSize: 14 }}>
                    {TYP_OPTIONEN.find(t => t.value === j.export_typ)?.icon || '📄'} {TYP_OPTIONEN.find(t => t.value === j.export_typ)?.label || j.export_typ}
                    <span style={{ marginLeft: 8, color: '#64748b', fontSize: 12 }}>({j.format?.toUpperCase()})</span>
                  </div>
                  <div style={{ color: '#64748b', fontSize: 12, marginTop: 4 }}>
                    Erstellt: {j.erstellt_am ? new Date(j.erstellt_am).toLocaleString('de-DE') : '—'}
                    {j.zeilen != null && <span style={{ marginLeft: 12 }}>{j.zeilen} Zeilen</span>}
                    {j.ablauf_am && <span style={{ marginLeft: 12 }}>· Ablauf: {new Date(j.ablauf_am).toLocaleString('de-DE')}</span>}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8, flexShrink: 0, alignItems: 'center' }}>
                  <span style={{ background: statusFarbe[j.status] || '#334155', color: '#fff', fontSize: 10, padding: '2px 6px', borderRadius: 4 }}>{j.status}</span>
                  {j.status === 'bereit' && (
                    <button onClick={() => handleDownload(j)} className="btn-primary">⬇ Download</button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const lbl = { display: 'block', color: '#94a3b8', fontSize: 12, marginBottom: 6 };
const sel = { background: '#0f172a', border: '1px solid #334155', color: '#f1f5f9', padding: '8px 10px', borderRadius: 6, fontSize: 13, width: '100%', boxSizing: 'border-box' };
